module.exports = __webpack_public_path__ + "static/media/bw_logo.15f0fb2d.svg";